<template>
  <v-card class="application-item">
    <v-toolbar color="teal darken-4" dark>
      <v-toolbar-side-icon left>{{ application.application_type.acronym }}</v-toolbar-side-icon>
      <v-toolbar-title>{{ application.application_type.name }}</v-toolbar-title>
      <v-spacer/>
      <span v-if="application.folder_number != undefined">
        Processo: {{ application.folder_number }}
      </span>

      <template>
        <generate-receipt-component :application="application"/>
        <application-historic-component :application="application"/>
        <download-file :application="application" :icon="true"/>
      </template>
    </v-toolbar>

    <v-list two-line subheader>
      <v-list-tile avatar @click="showApplication(application)">
        <v-list-tile-avatar>
          <v-icon>{{ personalTypeIcon }}</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{ application.person.name }}</v-list-tile-title>
          <v-list-tile-sub-title>
            {{ processCpfCnpj }}
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <small class="badge green">Aprovado</small>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import ApplicationService from '@/services/applications/ApplicationService';
import DownloadFile from '@/components/application/list/approved_application/DownloadFile';
import GenerateReceiptComponent from '@/components/application/list/approved_application/GenerateReceiptComponent';
import ApplicationHistoricComponent from '@/components/application/list/approved_application/ApplicationHistoricComponent';
import { isEmpty } from 'lodash';

export default {
  name: 'ApprovedApplication',
  components: {
    GenerateReceiptComponent,
    ApplicationHistoricComponent,
    DownloadFile
  },
  props: {
    application: {
      type: Object,
      default: () => {
      },
    },
    personalTypeIcon: {
      type: String,
      default: '',
    },
    processCpfCnpj: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
      url: '',
    };
  },
  methods: {
    showReceipt() {
      this.$store.dispatch('setLoadingDialog', true);
      const vm = this;
      ApplicationService
        .showReceipt(this.application.id)
        .then((response) => {
          vm.url = response.data.tmp_url;
          vm.dialog = true;
        })
        .catch(() => {
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  }
};
</script>
